var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("sorting")))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  !_vm.$wf.isMdUp
                    ? _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.sorting.ASC = !_vm.sorting.ASC
                            },
                          },
                        },
                        [
                          _vm.sorting.ASC
                            ? _c("w-fa", {
                                attrs: { icon: "sort-amount-down" },
                              })
                            : _c("w-fa", { attrs: { icon: "sort-amount-up" } }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("app-column-select", {
                    attrs: {
                      browse: _vm.browse,
                      model: _vm.model,
                      "is-server-column": "",
                    },
                    model: {
                      value: _vm.sorting.Column,
                      callback: function ($$v) {
                        _vm.$set(_vm.sorting, "Column", $$v)
                      },
                      expression: "sorting.Column",
                    },
                  }),
                ],
                1
              ),
              _vm.$wf.isMdUp
                ? _c(
                    "w-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.sorting.ASC = !_vm.sorting.ASC
                            },
                          },
                        },
                        [
                          _vm.sorting.ASC
                            ? _c("w-fa", {
                                attrs: { icon: "sort-amount-down" },
                              })
                            : _c("w-fa", { attrs: { icon: "sort-amount-up" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }